import styled from 'styled-components'

export const MainContainer = styled.div`
    margin-top: 20px;
    min-width: 1000px;
    max-height: 500px;
    overflow-y: auto;

    thead {
        position: sticky;
        top: 0;
        z-index: 9;
        border-top: 0;
    }

    table {
        border: 0;
    }
`

export const HoverCell = styled.td`
    position: relative;

    &:hover .copy-btn {
        opacity: 1;
    }
`

export const CopyBtn = styled.div`
    display: inline-block;
    margin-left: 8px;
    opacity: 0;
    transition: 0.2s;
`
